import { Model } from '@vuex-orm/core'
import fetchBySchool from 'src/store/models/helper/cacheHelper.js'
import Misc from 'src/api/misc.js'

export class SchoolLink extends Model {
  static entity = 'schoolLinks'
  static primaryKey = 'uuid'

  static fields () {
    return {
      uuid: this.string(''),
      school_id: this.attr(null),
      partner_uuid: this.string('').nullable(),
      filters: this.attr([]),
      name: this.attr(null),
      description: this.attr(null),
      link: this.attr(null),
      order: this.number(0),
      clicks: this.attr(0),
      type: this.attr(null),
      color: this.attr(null),
      deleted_at: this.number(0),
      created_at: this.number(0),
      updated_at: this.number(0)
    }
  }

  async $deleteLink () {
    return this.constructor.deleteLink(this)
  }

  static async fetchLinksBySchool (user) {
    await fetchBySchool(this, `${user.school.uri}/links`, this.primaryKey)
  }

  static async fetchPartnerLinksBySchool (user) {
    await fetchBySchool(this, `${user.school.uri}/partners`, this.primaryKey)
  }

  static async fetchAllLinksBySchool (user) {
    await this.fetchPartnerLinksBySchool(user)
    await this.fetchLinksBySchool(user)
  }

  static async deleteLink (link) {
    await Misc.deleteMiscLinksById(link.uuid)
    await SchoolLink.delete(l => l.uuid === link.uuid)
  }
}

export default SchoolLink
